// extracted by mini-css-extract-plugin
module.exports = {"container":"BlobContainer_container__dT-P5"};